import React from 'react';
import './App.css';
// import './try.css';
// import {NavBar} from './components/NavBar';
// import { Banner } from './components/Banner';
// import {Skills} from './components/Skills';
// import Contact from './components/Contact';
import 'bootstrap/dist/css/bootstrap.min.css';
import Layout from './Layout';


function App() {
  return (
    <div className="App">
      <Layout/>
      {/* <NavBar/>
      <Banner/>
      <Skills/>
      <Contact/> */}
    </div>
  );
}


export default App;